var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AppHeader'),_c('HeroSection',{attrs:{"id":"hero"}}),_c('ServicesSection',{attrs:{"id":"services"}}),_c('PortfolioSection',{attrs:{"id":"portfolio"}}),_c('AboutContactSection',{attrs:{"id":"about"}}),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }